import { SourceTypeResponse, SourceTypesQueryResponse } from "api/company";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { getNextPrioritySourceType, getPrioritySourceType } from "utils";

import { routes } from "config/urls";

export const useSourceTypeResolver = (
  params: { sourceType?: string },
  sourceTypes: SourceTypesQueryResponse | undefined
): {
  currentSourceType?: SourceTypeResponse;
  nextPrioritySourceType?: SourceTypeResponse;
} => {
  const history = useHistory();

  return useMemo(() => {
    if (sourceTypes) {
      if (params.sourceType) {
        const sourceTypeResponse = sourceTypes.find(
          (t) => t.sourceType.toLowerCase() === params.sourceType?.toLowerCase()
        );

        if (!sourceTypeResponse) {
          history.push(routes.notfound);
        }

        const nextPrioritySourceType =
          sourceTypeResponse &&
          getNextPrioritySourceType(sourceTypes, sourceTypeResponse);

        return {
          currentSourceType: sourceTypeResponse,
          nextPrioritySourceType,
        };
      }

      const currentSourceType = getPrioritySourceType(sourceTypes);

      return {
        currentSourceType,
        nextPrioritySourceType:
          currentSourceType &&
          getNextPrioritySourceType(sourceTypes, currentSourceType),
      };
    }

    return {};
  }, [params, sourceTypes, history]);
};
